import React, { useEffect } from "react";
import styles from "./ClientForm.module.css";

function Income({ formData, setFormData, nextStep, prevStep }) {
  useEffect(() => {
    if (!formData.applicant1?.employmentType) {
      setFormData({
        ...formData,
        applicant1: { ...(formData.applicant1 || {}), employmentType: "PAYG" },
      });
    }
  }, []);

  const formatDisplay = (value) => {
    if (!value) return "";
    return Number(value).toLocaleString("en-AU", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };

  const parseNumber = (value) => {
    if (!value) return "";
    return value.replace(/,/g, ""); // remove commas
  };

  const updateIncome = (applicant, value) => {
    const raw = parseNumber(value);
    setFormData({
      ...formData,
      [applicant]: { ...(formData[applicant] || {}), income: raw },
    });
  };

  return (
    <div className={styles.container}>
      <h3>Income</h3>

      <p>Applicant 1 Employment Type</p>
      <div className={styles.buttonGroup}>
        {["PAYG", "Self-Employed"].map((type) => (
          <button
            key={type}
            type="button"
            className={
              formData.applicant1?.employmentType === type ? styles.activeBtn : ""
            }
            onClick={() =>
              setFormData({
                ...formData,
                applicant1: { ...(formData.applicant1 || {}), employmentType: type },
              })
            }
          >
            {type}
          </button>
        ))}
      </div>

      <div className={styles.currencyInput}>
        <span className={styles.prefix}>$</span>
        <input
          type="text"
          placeholder="e.g. 80,000"
          value={formatDisplay(formData.applicant1?.income || "")}
          onChange={(e) => updateIncome("applicant1", e.target.value)}
          required
        />
      </div>

      {formData.buyingWithSomeone && (
        <>
          <p>Applicant 2 Employment Type</p>
          <div className={styles.buttonGroup}>
            {["PAYG", "Self-Employed"].map((type) => (
              <button
                key={type}
                type="button"
                className={
                  formData.applicant2?.employmentType === type
                    ? styles.activeBtn
                    : ""
                }
                onClick={() =>
                  setFormData({
                    ...formData,
                    applicant2: { ...(formData.applicant2 || {}), employmentType: type },
                  })
                }
              >
                {type}
              </button>
            ))}
          </div>

          <div className={styles.currencyInput}>
            <span className={styles.prefix}>$</span>
            <input
              type="text"
              placeholder="e.g. 70,000"
              value={formatDisplay(formData.applicant2?.income || "")}
              onChange={(e) => updateIncome("applicant2", e.target.value)}
              required
            />
          </div>
        </>
      )}

      <div className={styles.navBtns}>
        <button type="button" onClick={prevStep}>
          ← Back
        </button>
        <button type="button" className={styles.nextBtn} onClick={nextStep}>
          Next →
        </button>
      </div>
    </div>
  );
}

export default Income;
